import { render } from "./DeviceSettingTabs.vue?vue&type=template&id=9d0d0a68"
import script from "./DeviceSettingTabs.vue?vue&type=script&lang=js"
export * from "./DeviceSettingTabs.vue?vue&type=script&lang=js"

import "./DeviceSettingTabs.vue?vue&type=style&index=0&id=9d0d0a68&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__